export default [
    {
        path: "/aigc/xiaohongshu/list",
        name: "agic-xiaohongshu-list",
        component: () => import("@/views/aigc/xiaohongshu/list.vue"),
    },
    {
        path: "/aigc/xiaohongshu/create",
        name: "agic-xiaohongshu-create",
        component: () => import("@/views/aigc/xiaohongshu/create.vue"),
    },
    {
        path: "/aigc/videoscript/list",
        name: "agic-videoscript-list",
        component: () => import("@/views/aigc/videoscript/list.vue"),
    },
    {
        path: "/aigc/videoscript/create",
        name: "agic-videoscript-create",
        component: () => import("@/views/aigc/videoscript/create.vue"),
    },
    {
        path: "/aigc/copyextract/list",
        name: "agic-copyextract-list",
        component: () => import("@/views/aigc/copyextract/list.vue"),
    },
    {
        path: "/aigc/copyextract/create",
        name: "agic-copyextract-create",
        component: () => import("@/views/aigc/copyextract/create.vue"),
    },
    {
        path: "/aigc/outline/list",
        name: "agic-outline-list",
        component: () => import("@/views/aigc/outline/list.vue"),
    },
    {
        path: "/aigc/outline/create",
        name: "agic-outline-create",
        component: () => import("@/views/aigc/outline/create.vue"),
    },
    {
        path: "/aigc/writing/create",
        name: "agic-writing-create",
        component: () => import("@/views/aigc/writing/create.vue"),
    },
    {
        path: "/aigc/writing/list",
        name: "agic-writing-list",
        component: () => import("@/views/aigc/writing/list.vue"),
    },
    {
        path: "/aigc/embellish/list",
        name: "agic-embellish-list",
        component: () => import("@/views/aigc/embellish/list.vue"),
    },
    {
        path: "/aigc/embellish/create",
        name: "agic-embellish-create",
        component: () => import("@/views/aigc/embellish/create.vue"),
    },
    {
        path: "/aigc/dianping/list",
        name: "agic-dianping-list",
        component: () => import("@/views/aigc/dianping/list.vue"),
    },
    {
        path: "/aigc/dianping/create",
        name: "agic-dianping-create",
        component: () => import("@/views/aigc/dianping/create.vue"),
    },
    {
        path: "/aigc/comment/list",
        name: "agic-comment-list",
        component: () => import("@/views/aigc/comment/list.vue"),
    },
    {
        path: "/aigc/comment/create",
        name: "agic-comment-create",
        component: () => import("@/views/aigc/comment/create.vue"),
    },
    {
        path: "/aigc/insight/list",
        name: "agic-insight-list",
        component: () => import("@/views/aigc/insight/list.vue"),
    },
    {
        path: "/aigc/insight/create",
        name: "agic-insight-create",
        component: () => import("@/views/aigc/insight/create.vue"),
    },
    {
        path: "/aigc/xhshot/create",
        name: "agic-xhshot-create",
        component: () => import("@/views/aigc/xhshot/create.vue"),
    },
    {
        path: "/aigc/xhshot/list",
        name: "agic-xhshot-list",
        component: () => import("@/views/aigc/xhshot/list.vue"),
    },
]